module.exports = __webpack_public_path__ + "static/media/certified3.19a58c6c.png";